import * as i0 from '@angular/core';
import { InjectionToken, makeEnvironmentProviders, inject, Injectable } from '@angular/core';

/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
/** Injection Token for providing the nav items. */
const FAB_ICON_THEME = new InjectionToken('fab.icon.theme');
/**
 * This function provides the global icon theme to standalone applications
 * @param iconTheme Icon theme you'd like to apply globally
 * @returns Environment provider for the icon theme injection token
 */
function provideIconTheme(iconTheme) {
    return makeEnvironmentProviders([{ provide: FAB_ICON_THEME, useValue: iconTheme }]);
}

/*
 * Copyright (c) 2022-2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
const materialClassBase = 'material-icons';
class FabIconConfigService {
    constructor() {
        /** Theme retrieved from injection token, if provided. */
        this.iconTheme = inject(FAB_ICON_THEME, { optional: true });
        // Default to outlined if nothing was provided by the app team
        this.iconTheme ??= 'outlined';
    }
    /**
     * If 'filled', then use the base material icon class.  Otherwise, append the theme name to the base class name.
     * e.g. material-icons-outlined
     * @returns the full css class name for the current icon theme (either `material-icons` or `material-icons-outlined`)
     */
    get iconClass() {
        return this.iconTheme === 'filled' ? materialClassBase : `${materialClassBase}-${this.iconTheme}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: FabIconConfigService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: FabIconConfigService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.7", ngImport: i0, type: FabIconConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
/**
 * Created by michael faith on 8/10/2020.
 */

/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
/**
 * Created by michael faith on 8/10/2020.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FAB_ICON_THEME, FabIconConfigService, provideIconTheme };
